module.exports = __webpack_public_path__ + "static/media/feather_clock.f8bdb4ab.svg";